import { createReducer } from '@reduxjs/toolkit';

const initialState = [];

/**
 * Keeps user grid data state
 *
 * @param  {Array} state: the new state
 * @param  {Object} action: action to be performed
 * @return {Object} the new state
 */
const userGridData = createReducer(initialState, {
  GET_USERS: (state, { value }) => value.payload,
});

export default userGridData;
